import { useCallback } from 'react';
import { TableProps } from 'antd';
import ActionColumn from './components/ActionColumn/ActionColumn';

interface RenderActionColumnProps {
  mapColumns: TableProps['columns'] | null;
}

const useRenderActionColumn = ({
  mapColumns,
}: RenderActionColumnProps): TableProps['columns'] | null => {
  // eslint-disable-next-line
  const renderActionColumn = useCallback((_text: any, record: any) => {
    return <ActionColumn record={record} />;
  }, []);

  if (renderActionColumn && mapColumns) {
    const columns = [...mapColumns];

    columns.push({
      title: 'ACTION',
      dataIndex: 'action',
      key: 'action',
      width: 80,
      fixed: 'right',
      render: renderActionColumn,
    });

    return columns;
  }

  return null;
};

export default useRenderActionColumn;
